// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/employees/{employeeId}/insurance-infos",
  Create: "/pyr/employees/{employeeId}/insurance-infos",
  Update: "/pyr/employees/{employeeId}/insurance-infos",
  Detail: "/pyr/employees/{employeeId}/insurance-infos",
};
